import { render } from "./Thank-you.vue?vue&type=template&id=7c45f940&scoped=true"
import script from "./Thank-you.vue?vue&type=script&lang=js"
export * from "./Thank-you.vue?vue&type=script&lang=js"

import "./Thank-you.vue?vue&type=style&index=0&id=7c45f940&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c45f940"]])

export default __exports__